/**
 * @generated SignedSource<<b33a661a5c0e7551d33e436dcadc5c2b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ClickupListSelectorWithFolderQuery$variables = {
  folderId: string;
};
export type ClickupListSelectorWithFolderQuery$data = {
  readonly viewer: {
    readonly integrations: {
      readonly clickup: {
        readonly lists: ReadonlyArray<{
          readonly externalId: string;
          readonly id: string;
          readonly name: string;
        }> | null;
      } | null;
    };
  };
};
export type ClickupListSelectorWithFolderQuery = {
  response: ClickupListSelectorWithFolderQuery$data;
  variables: ClickupListSelectorWithFolderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "folderId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": "lists",
  "args": [
    {
      "kind": "Variable",
      "name": "folderId",
      "variableName": "folderId"
    }
  ],
  "concreteType": "ClickupListNode",
  "kind": "LinkedField",
  "name": "folderLists",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalId",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ClickupListSelectorWithFolderQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ClickupUserNode",
                "kind": "LinkedField",
                "name": "clickup",
                "plural": false,
                "selections": [
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ClickupListSelectorWithFolderQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ClickupUserNode",
                "kind": "LinkedField",
                "name": "clickup",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3ada52f8897c656a8012537638f2880d",
    "id": null,
    "metadata": {},
    "name": "ClickupListSelectorWithFolderQuery",
    "operationKind": "query",
    "text": "query ClickupListSelectorWithFolderQuery(\n  $folderId: String!\n) {\n  viewer {\n    integrations {\n      clickup {\n        lists: folderLists(folderId: $folderId) {\n          id\n          name\n          externalId\n        }\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "836527b6545fefbabbdbc4b665167f61";

export default node;
